import { FormattedMessage } from 'react-intl';

import type { Props as LoadingButtonProps } from '#src/atoms/buttons/LoadingButton/index.tsx';
import { LoadingButton } from '#src/atoms/buttons/LoadingButton/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

export interface Props extends Omit<LoadingButtonProps, 'size'> {
  hasMore?: boolean;
  loading: boolean;
  loadMore: () => void;
}

export const LoadMoreButton = ({
  hasMore,
  loading,
  loadMore,
  ...rest
}: Props) => {
  if (!hasMore) return null;

  return (
    <LoadingButton
      loading={loading}
      color="tertiary"
      size="medium"
      disabled={loading}
      onClick={loadMore}
      {...rest}
    >
      <FormattedMessage {...glossary.loadMore} />
    </LoadingButton>
  );
};
